import React from 'react';
import { FaBuilding, FaHotel, FaProjectDiagram, FaLightbulb, FaChartLine } from 'react-icons/fa';

const ServiceCard = ({ icon, title, description, image }) => (
  <div className="bg-white rounded-lg mb-14 shadow-lg shadow-white overflow-hidden transition-transform duration-300 hover:scale-105">
    {image && (
      <img src={image || "/placeholder.svg"} alt={title} className="w-full h-48 object-cover" />
    )}
    <div className="p-6">
      <div className="text-4xl text-blue-600 mb-4">{icon}</div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

const ServicesPage = () => {
  return (
    <div className="bg-gray-100  p-10">

      <main className="container mx-auto py-16 my-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <ServiceCard
            icon={<FaBuilding />}
            title="Property Development"
            description="We specialize in developing uniquely designed, functional, and safe residential and commercial properties. Our projects are characterized by meticulous planning, innovative design, and high-quality construction, ensuring they meet the highest standards and provide excellent returns on investment."
            image="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          />
          <ServiceCard
            icon={<FaHotel />}
            title="Hospitality"
            description="Harbourage is committed to enhancing the hospitality sector by developing world-class hotels, resorts, and recreational facilities. We focus on creating luxurious, comfortable, and memorable experiences for guests, setting new benchmarks in hospitality excellence."
            image="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          />
          <ServiceCard
            icon={<FaProjectDiagram />}
            title="Project Management"
            description="Our project management team ensures that every project is delivered on time, within budget, and to the highest quality standards. We oversee all aspects of the development process, from initial planning and design through to construction and final handover, ensuring a seamless and efficient execution."
            image="https://images.unsplash.com/photo-1507207611509-ec012433ff52?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          />
          <ServiceCard
            icon={<FaLightbulb />}
            title="Consultancy"
            description="We offer expert consultancy services to guide our clients (individuals and companies) through the complexities of real estate development and investment. Our consultancy team provides valuable insights, strategic advice, and practical solutions to help clients make informed decisions and achieve their real estate goals."
            image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          />
          <ServiceCard
            icon={<FaChartLine />}
            title="Investment"
            description="Harbourage provides investment opportunities that offer high returns and long-term value. We analyze market trends and patterns to identify lucrative investment prospects, helping our clients grow their wealth through strategic real estate investments."
            image="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2015&q=80"
          />
        </div>

        <section className="mt-16">
          <h2 className="text-3xl font-bold text-center  mb-8">Featured Projects</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <img src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Luxury Hotel" className="rounded-lg shadow-lg w-full h-64 object-cover" />
            <img src="https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2081&q=80" alt="Modern Office Building" className="rounded-lg shadow-lg w-full h-64 object-cover" />
            <img src="https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80" alt="Residential Complex" className="rounded-lg shadow-lg w-full h-64 object-cover" />
          </div>
        </section>

      </main>


    </div>
  );
};

export default ServicesPage;

